import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ProductRecord, VendorRecord } from '../types';

export class MaintenanceWindowPatchManagementVendorProductSelectorBaseDataProvider extends BaseWebComponentDataProvider {
  async getAllVendors(): Promise<VendorRecord[]> {
    throw new Error('Not implemented');
  }
  async getProductsForVendor(params: { vendorId: string }): Promise<ProductRecord[]> {
    throw new Error('Not implemented');
  }
}
